(function () {
  'use strict';

  angular
      .module('checker.core')
      .constant('API_KEYS', {
        'VERSION_ENDPOINT': '//www.hiv-druginteractions.org/iPhoneService.asmx',
        'DATA_ENDPOINT': '//www.hiv-druginteractions.org/iPhoneDataService.asmx',
        'PASSWORD': 'l1v3rp00l_data'
      })
      .constant('API_META', {
        // English
        'HIV_DRUG_ENDPOINT_EN': '/api/v1/hiv_drugs',
        'HIV_DRUG_CLASS_NAME_ENDPOINT_EN': '/api/v1/hiv_drug_classes',
        'HIV_DRUG_TRADE_NAMES_ENDPOINT': '/api/v1/hiv_primary_trade_names',
        'HIV_COMED_ENDPOINT_EN': '/api/v1/hiv_comeds',
        'HIV_COMED_CLASS_NAME_ENDPOINT_EN': '/api/v1/hiv_comed_classes',
        'HIV_COMED_TRADE_NAMES_ENDPOINT': '/api/v1/hiv_comed_trade_names',
        'HIV_UNAPPROVED_AND_PRIMARY_ENDPOINT': '/api/v1/hiv_unapproved_and_primary',
        'HIV_UNAPPROVED_AND_COMED_ENDPOINT': '/api/v1/hiv_unapproved_and_comed',
        'HIV_INTERACTION_ENDPOINT_EN': '/api/hiv_interactions',
        'HEP_DRUG_ENDPOINT_EN': '/api/v1/hep_drugs',
        'HEP_DRUG_CLASS_NAME_ENDPOINT_EN': '/api/v1/hep_drug_classes',
        'HEP_DRUG_TRADE_NAMES_ENDPOINT': '/api/v1/hep_primary_trade_names',
        'HEP_COMED_ENDPOINT_EN': '/api/v1/hep_comeds',
        'HEP_COMED_CLASS_NAME_ENDPOINT_EN': '/api/v1/hep_comed_classes',
        'HEP_COMED_TRADE_NAMES_ENDPOINT': '/api/v1/hep_comed_trade_names',
        'HEP_UNAPPROVED_AND_PRIMARY_ENDPOINT': '/api/v1/hep_unapproved_and_primary',
        'HEP_UNAPPROVED_AND_COMED_ENDPOINT': '/api/v1/hep_unapproved_and_comed',
        'HEP_INTERACTION_ENDPOINT_EN': '/api/hep_interactions',
        'HEP_INDICATIONS_ENDPOINT': '/api/v1/indications',
        'HEP_ADMIN_INDICATIONS_ENDPOINT': '/api/v1/indications?admin=true',

        'X-Api-Key': '3bd4b2bf7a417b5c5fefd155dd241c34',

        // Spanish
        'HIV_DRUG_ENDPOINT_ES': '/api/v1/hiv_drugs?lang=es',
        'HIV_DRUG_CLASS_NAME_ENDPOINT_ES': '/api/v1/hiv_drug_classes?lang=es',
        'HIV_COMED_ENDPOINT_ES': '/api/v1/hiv_comeds?lang=es',
        'HIV_COMED_CLASS_NAME_ENDPOINT_ES': '/api/v1/hiv_comed_classes?lang=es',
        'HIV_INTERACTION_ENDPOINT_ES': '/api/hiv_interactions?lang=es',

        'HEP_DRUG_ENDPOINT_ES': '/api/v1/hep_drugs?lang=es',
        'HEP_DRUG_CLASS_NAME_ENDPOINT_ES': '/api/v1/hep_drug_classes?lang=es',
        'HEP_COMED_ENDPOINT_ES': '/api/v1/hep_comeds?lang=es',
        'HEP_COMED_CLASS_NAME_ENDPOINT_ES': '/api/v1/hep_comed_classes?lang=es',
        'HEP_INTERACTION_ENDPOINT_ES': '/api/hep_interactions?lang=es',

        // Portuguese
        'HIV_DRUG_ENDPOINT_PT': '/api/v1/hiv_drugs?lang=pt',
        'HIV_DRUG_CLASS_NAME_ENDPOINT_PT': '/api/v1/hiv_drug_classes?lang=pt',
        'HIV_COMED_ENDPOINT_PT': '/api/v1/hiv_comeds?lang=pt',
        'HIV_COMED_CLASS_NAME_ENDPOINT_PT': '/api/v1/hiv_comed_classes?lang=pt',
        'HIV_INTERACTION_ENDPOINT_PT': '/api/hiv_interactions?lang=pt',

        'HEP_DRUG_ENDPOINT_PT': '/api/v1/hep_drugs?lang=pt',
        'HEP_DRUG_CLASS_NAME_ENDPOINT_PT': '/api/v1/hep_drug_classes?lang=pt',
        'HEP_COMED_ENDPOINT_PT': '/api/v1/hep_comeds?lang=pt',
        'HEP_COMED_CLASS_NAME_ENDPOINT_PT': '/api/v1/hep_comed_classes?lang=pt',
        'HEP_INTERACTION_ENDPOINT_PT': '/api/hep_interactions?lang=pt',

        // French
        'HIV_DRUG_ENDPOINT_FR': '/api/v1/hiv_drugs?lang=fr',
        'HIV_DRUG_CLASS_NAME_ENDPOINT_FR': '/api/v1/hiv_drug_classes?lang=fr',
        'HIV_COMED_ENDPOINT_FR': '/api/v1/hiv_comeds?lang=fr',
        'HIV_COMED_CLASS_NAME_ENDPOINT_FR': '/api/v1/hiv_comed_classes?lang=fr',
        'HIV_INTERACTION_ENDPOINT_FR': '/api/hiv_interactions?lang=fr'

      })
      .constant('GRADES', {
        'es': ["Sin Establecer", "Alta", "Moderada", "Baja", "Muy Baja"],
        'pt': ["Não configurado", "Alto", "Moderado", "Baixo", "Muito Baixo"],
        'fr': ["Non défini", "Haut", "Modéré", "Faible", "Très faible"],
        'en': [ "Not set", "High", "Moderate", "Low", "Very Low"] 
      })
      .constant('SUMMARIES', {
        'es': ["No Coadministrar", "Posible Interacción", "Sin Interacción Esperada", "Sin Datos Claros", "Posible Interacción Débil"],
        'pt': ["Não Coadministrar", "Interação Potencial", "Não Se Espera Interação", "Não Há Dados Claros", "Possível Interação Fraca"],
        'fr': ["Ne Pas Coadministrer", "Interaction Potentielle", "Aucune Interaction Attendue", "Pas De Données Claires", "Interaction Faible Potentielle"],
        'en': ["Do Not Coadminister", "Potential Interaction", "No Interaction Expected", "No Clear Data", "Potential Weak Interaction"]
      });
})();